<div class="navbarclass menu-wrapper" [class.nav-collapsed]="navCollapsed">
  @if (signedIn && company) {
    <dx-drop-down-button [items]="dropdownItems" [useSelectMode]="false"
      [dropDownOptions]="{ width: 150, wrapperAttr: { class: 'app-switcher-popup' }, position: { my: 'left top', at: 'left bottom', of: '.navbarclass', offset: '5 3' } }"
      icon="assets/9dots.png" class="menuDropDown">
      <div *dxTemplate="let item of 'item'">
        <img [src]="item.icon" class="dropDownLogo" alt="">
        <span class="dropdownOptionText">{{ item.text }}</span>
      </div>
    </dx-drop-down-button>
  }

  <button type="button" class="logo-btn brand-logo-button" (click)="goHome()" aria-label="Go to home page">
    <img
      class="brand-logo"
      src="assets/logotransparentlowercase.png"
      alt="Truth Engine"
      loading="eager"
      decoding="sync"
      draggable="false">
  </button>

  <nav #innerNav class="navbar navbar-expand-md navbar-light inner-nav">
    @if (signedIn && company) {
      <div class="title ms-1">
        {{ title }}
      </div>
      @if (isUAT) {
        <h3 class="title uatClass"><b>TEST</b></h3>
      }
      @if (innerWidth > 767) {
        <span class="cust-divider-vertical"></span>
      }
      <div class="menu-collapse">
        <ul class="navbar-nav mr-auto mt-2 mt-lg-0" style="margin-top: 0!important;">
          @for (tab of navTabs; track tab.path) {
            <a class="nav-item active nav-link tab" [routerLink]="tab.path" routerLinkActive="selected">{{ tab.text }}</a>
          }
        </ul>
      </div>
      <js-thomas-widget></js-thomas-widget>

      <div class="curr-comp-wrap">
        <a class="currComp" role="button" tabindex="0" (click)="goHome()" (keydown.enter)="goHome()">{{ company.companyShortName }}</a>
      </div>

      @if (navCollapsed) {
        <dx-drop-down-button class="active-tab-dropdown"
          [text]="activeTabText" [items]="collapsedMenuItems" [useSelectMode]="false"
          [dropDownOptions]="{ width: 'auto', wrapperAttr: { class: 'nav-menu-popup' }, position: { my: 'right top', at: 'right bottom', of: '.navbarclass', offset: '-10 3' } }"
          itemTemplate="navMenuItem"
          (onButtonClick)="buildNavMenuItems()"
          (onItemClick)="onCollapsedItemClick($event)">
          <div *dxTemplate="let item of 'navMenuItem'">
            <span class="nav-menu-item-text" [class.active-nav-item]="item.path && item.path === activeTab?.path"
              [class.nav-menu-extra]="item.isAskAi || item.isCompany">
              <span class="nav-menu-item-label">{{ item.text }}</span>
            </span>
          </div>
        </dx-drop-down-button>
      }
    }
  </nav>
</div>
